import React from 'react'
import PropTypes from 'prop-types'
// import { View, StyleSheet } from 'react-native'
import { Spacing } from '../../global'
import { View } from '@aws-amplify/ui-react'

const stylesGutter = {
  none: {
    marginLeft: 0,
    marginRight: 0,
  },
  xm: {
    marginLeft: Spacing.xm,
    marginRight: Spacing.xm,
  },
  sm: {
    marginLeft: Spacing.sm,
    marginRight: Spacing.sm,
  },
  md: {
    marginLeft: Spacing.md,
    marginRight: Spacing.md,
  },
  lg: {
    marginLeft: Spacing.lg,
    marginRight: Spacing.lg,
  },
  xl: {
    marginLeft: Spacing.xl,
    marginRight: Spacing.xl,
  },
}

const stylesPadding = {
  none: {
    padding: 0,
  },
  xm: {
    padding: Spacing.xm,
  },
  sm: {
    padding: Spacing.sm,
  },
  md: {
    padding: Spacing.md,
  },
  lg: {
    padding: Spacing.lg,
  },
  xl: {
    padding: Spacing.xl,
  },
}

const stylesSidePadding = {
  none: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  xm: {
    paddingLeft: Spacing.xm,
    paddingRight: Spacing.xm,
  },
  sm: {
    paddingLeft: Spacing.sm,
    paddingRight: Spacing.sm,
  },
  md: {
    paddingLeft: Spacing.md,
    paddingRight: Spacing.md,
  },
  lg: {
    paddingLeft: Spacing.lg,
    paddingRight: Spacing.lg,
  },
  xl: {
    paddingLeft: Spacing.xl,
    paddingRight: Spacing.xl,
  },
}

const ViewComponent = ({ as: Component, gutter, sidePadding, padding, style, ...rest }) => {
  if(Array.isArray(style)) style = Object.assign({}, ...style)
  return (
  <div style={{ ...stylesSidePadding[sidePadding],...stylesPadding[padding], ...stylesGutter[gutter], ...style}} {...rest} />
)}

// ViewComponent.defaultProps = {
//   as: div,
//   gutter: '',
//   padding: 'none',
//   sidePadding:'none',
//   style: null,
// }

// ViewComponent.propTypes = {
//   as: PropTypes.any,
//   gutter: PropTypes.oneOf(['', 'none', 'xm', 'sm', 'md', 'lg', 'xl']),
//   padding: PropTypes.oneOf(['', 'none', 'xm', 'sm', 'md', 'lg', 'xl']),
//   sidePadding: PropTypes.oneOf(['', 'none', 'xm', 'sm', 'md', 'lg', 'xl']),
//   style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
// }

export default ViewComponent
